import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AuthSelectors, ClientOptionsDispatchers, ClientOptionsSelectors, SessionSelectors } from '@store';

@Component({
    selector: 'app-statistik-ydelse',
    template: `
        <app-statistik-ydelse-ui
            [kundelistWithYdelser]="kundelistWithYdelser$ | async"
            [ydelserList]="ydelserList$ | async"
            [laCards]="laCards$ | async"
            [kaCards]="kaCards$ | async"
            [saCards]="saCards$ | async"
            [periode]="periode$ | async"
            [user]="user$ | async"
            [laID]="la$ | async"
            [kaID]="ka$ | async"
            [saID]="sa$ | async"
            (periodeChange)="periodeChange($event)"
            (laChange)="laSubject.next($event)"
            (kaChange)="kaSubject.next($event)"
            (saChange)="saSubject.next($event)"
        ></app-statistik-ydelse-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikYdelserContainer {
    periodeSubject = new BehaviorSubject<{fra: string, til: string}>({fra: null, til: null});
    periode$ = this.periodeSubject.asObservable();
    laSubject = new BehaviorSubject<number>(null);
    la$ = this.laSubject.asObservable();
    kaSubject = new BehaviorSubject<number>(null);
    ka$ = this.kaSubject.asObservable();
    saSubject = new BehaviorSubject<number>(null);
    sa$ = this.saSubject.asObservable();
    kundelistWithYdelser$ = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$,
        this.la$,
        this.ka$,
        this.sa$
    ]).pipe(
        filter(([visible, step]) => visible && step === 6),
        switchMap(([, , periode, la, ka, sa]) => this.statistikService.getYdelser(periode, la, ka, sa))
    );
    ydelserList$ = this.clientOptionsSelectors.v2Ydelser$;
    laCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersLA$(new Date(date.fra))));
    kaCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersKA$(new Date(date.fra))));
    saCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersSA$(new Date(date.fra))));
    user$ = this.authSelector.user$;

    constructor(
        private statistikService: StatistikService,
        private sessionSelector: SessionSelectors,
        private clientOptionsSelectors: ClientOptionsSelectors,
        private clientsOptionsDispatch: ClientOptionsDispatchers,
        private authSelector: AuthSelectors,
    ) {
        this.clientsOptionsDispatch.loadClientOptions();
    }

    periodeChange(periode: {fra: string; til: string}) {
        this.periodeSubject.next(periode);
    }
}

